var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { staticClass: "form-group" }, [
      _c("label", [
        _vm._v(
          _vm._s(_vm.$t("workflow.vueFormBuilder.elements.static.model.tag"))
        )
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.tag,
            expression: "tag"
          }
        ],
        staticClass: "form-control",
        domProps: { value: _vm.tag },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.tag = $event.target.value
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", [
        _vm._v(
          _vm._s(
            _vm.$t("workflow.vueFormBuilder.elements.static.model.content")
          )
        )
      ]),
      _vm._v(" "),
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.content,
            expression: "content"
          }
        ],
        staticClass: "form-control",
        attrs: { rows: "2" },
        domProps: { value: _vm.content },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.content = $event.target.value
          }
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }